import { updateLeadParams } from './updateLead';
import { createAddressPayload } from './addressPayload';

export const getUpdateParamsFunc = (type) => {
  switch (type) {
    case 'updateLead':
      return updateLeadParams;
    case 'address':
      return createAddressPayload;
    default:
      return '';
  }
};
